import React from "react";
import PropTypes from "prop-types";

import styles from "./TitledContainer.css";

const PlaceholderButton = (props) => (
  <button className={styles.placeholderBtn} onClick={props.onClick}>
    <span>+</span>
    &nbsp;
    <span>{props.text}</span>
  </button>
);

PlaceholderButton.propTypes = {
  text: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
};

export default PlaceholderButton;
